<template>
  <div class="activity-wrap">
    <app-header />
    <div class="app">
      <div class="top-title">
        <p>开通大智慧365</p>
        <p>轻松锁定强势股</p>
      </div>
      <div class="content">
        <div class="c-bottom">
          <div class="c-bottom-left">
            <p class="c-titlt1">升级服务</p>
            <p class="c-titlt2">尊享以下权益</p>

            <ul class="list-ul">
              <li
                v-for="(item, index) in list"
                :key="index"
                class="item"
                :class="tabCheckedIndex == index ? 'tabCheckedClass' : ''"
                @click="jump(item.url)"
              >
                <p>{{ item.name }}</p>
                <p>></p>
              </li>
            </ul>
          </div>
          <div class="c-bottom-right">
            <p class="right-title">请选择适合您的套餐</p>

            <ul class="timeList-ul">
              <li
                v-for="(item, index) in timeList"
                :key="index"
                :class="timeCheckedIndex == index ? 'timeCheckedClass' : ''"
                @click="changeAttach(index)"
              >
                <span v-if="item.discounts" class="discounts">首月特惠</span>
                <div>
                  <p class="time">{{ item.time }}</p>
                  <p class="price">
                    <i>¥</i>
                    {{ item.price }}
                  </p>
                  <p class="old" v-if="item.old">
                    原价
                    <i>{{ item.old }}</i>
                  </p>
                </div>

                <img
                  v-if="timeCheckedIndex == index"
                  src="../../assets/images/activity/newUserActivity0628/checked.png"
                  alt=""
                  class="checked"
                />
              </li>
            </ul>

            <div class="pay-hint" v-show="showRenewNotice">
              <div
                class="arrow-up"
                :style="timeCheckedIndex == 0 ? 'left: 29%' : 'left: 70%'"
              ></div>
              购买后获得一个月大智慧365软件权益，到期前一天按83元/月自动续费，可随时取消。
            </div>

            <div class="c-bottom-pay">
              <div class="left">
                <p class="nth-child1">
                  <span class="style1">同意并支付¥</span> 
                  <span class="style2">{{ payMoney }}</span>
                  <i class="style3">{{ oriMoney }}</i>
                </p>

                <div class="nth-child2">
                  <el-checkbox v-model="checked"></el-checkbox>
                  &nbsp;
                  <span>我已知晓</span>
                  <a href=""><router-link to="/protocol" target="_blank">软件许可协议</router-link></a>
                  <a v-show="autoRenew" href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000051" target="_blank">丨付费授权协议</a>
                  <a v-show="autoRenew" href=""><router-link to="/activity/agree_1" target="_blank">丨自动续费协议</router-link></a>
                </div>

                <div class="nth-child3">
                  发票信息：电子普通发票 
                  <span v-if="this.invoiceTitleType == 1">个人</span>
                  <span v-else>单位</span>
                  信息技术服务 <a @click="openInvoice()">发票填开></a>
                </div>
              </div>
              <!-- 电子发票组件 -->
              <invoice @changeInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />

              <button class="open-btn" @click="saveOrder()">
                立即开通>
              </button>
            </div>
          </div>
        </div>
        <p class="btm-hint">
          如遇到支付问题，可随时拨打
          021-20219999，客服将第一时间帮你解决。如需了解详情可点击进入大智慧官网
          <a href="https://www.gw.com.cn/">www.gw.com.cn</a>
        </p>
      </div>

      <!-- <div class="shade-bg" v-if="shadebg"> -->
        <!-- 支付成功 -->
        <!-- <div class="payment-success" v-if="success">
          <div>
            <svg
              t="1720006997072"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6432"
              width="70"
              height="70"
            >
              <path
                d="M526.925944 110.523209c-212.498742 0-384.763131 172.264389-384.763131 384.763131s172.264389 384.763131 384.763131 384.763131 384.763131-172.264389 384.763131-384.763131S739.424686 110.523209 526.925944 110.523209zM485.358223 698.317453c-1.696642 3.266393-3.911076 6.334265-6.652514 9.074679-13.519921 13.519921-34.933627 14.329357-49.403177 2.434445-1.411139-1.052982-2.765997-2.215458-4.047176-3.496637-0.937348-0.937348-1.811252-1.914606-2.626827-2.923586L270.343171 551.120996c-14.384615-14.384615-14.384615-37.705763 0-52.090379s37.705763-14.384615 52.090379 0l129.015376 129.015376 282.793738-282.793738c14.384615-14.384615 37.705763-14.384615 52.090379 0s14.384615 37.705763 0 52.090379L485.358223 698.317453z"
                fill="#00A2FD"
                p-id="6433"
              ></path>
            </svg>
          </div>

          <p style="color: #000000; font-size: 20px">支付成功</p>
          <p style="margin-top: 15px; color: #333">当您重启软件后</p>
          <p style="color: #333">权益将立即生效</p>

          <button class="affirm-btn" @click="shadebg = false">确认</button>
        </div> -->

        <!-- 挽留 -->
        <div class="leave" v-if="leave">
          <img
            src="../../assets/images/activity/newUserActivity0628/wl.png"
            alt=""
          />
          <img
            src="../../assets/images/activity/newUserActivity0628/close.png"
            alt=""
            class="close"
            @click="shadebg = false"
          />

          <div class="leave-con">
            <div class="leave-con-left">
              <div>
                <p class="l-nth-child1">连续包月</p>
                <p class="l-nth-child2">
                  <i>¥</i>
                  39.9
                </p>
                <p class="l-nth-child3">
                  原价
                  <i>¥83</i>
                </p>
              </div>
            </div>

            <div class="leave-con-right">
              <div>
                <div class="code">
                  我已知晓软件许可协议|付费授权协议|自动续费协议
                  次月以￥83/月续费，可随时取消
                </div>
                <button class="pop-up-open-btn">立即开通></button>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->

      <!-- 支付提示 -->
      <div class="shade-bg" v-if="payHint">
        <div class="payHint">
          <i class="el-icon-close" @click="payHint = false"></i>
          <p class="title">支付提示</p>

          <div class="msg">
            我同意并接受 <span>《软件许可协议》</span>
            <span v-show="autoRenew" >            
              <span >《付费授权协议》《自动续费协议》</span>
              到期前一天按83元/月自动续费，可随时取消
            </span>
          </div>

          <div style="text-align: right;margin-top: 16px;">
            <button
              class="btn"
              @click="
                checked = true;
                payHint = false;
              "
            >
              同意并支付
            </button>
          </div>
        </div>
      </div>

      <!-- 支付成功 -->
      <div class="shade-bg" v-if="paySucceed">
        <div class="paySucceed">
          <i class="el-icon-close" @click="paySucceed = false"></i>

          <div class="title">
            <svg
              t="1721109567180"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4250"
              width="28"
              height="28"
            >
              <path
                d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333z m182.613333 297.354667a32 32 0 0 0-45.258666 0.032L458.922667 573.44l-84.341334-83.989333a32 32 0 0 0-45.162666 45.344l106.986666 106.549333a32 32 0 0 0 45.226667-0.064l213.013333-213.333333a32 32 0 0 0-0.032-45.258667z"
                fill="#086bff"
                p-id="4251"
              ></path>
            </svg>
            <p>
              支付成功
            </p>
          </div>

          <div class="msg">当您重启软件后<br />权益将立即生效</div>

          <div style="margin-top: 16px;">
            <button class="btn" @click="paySucceed = false">
              确认
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script></script>
<script>
// import AppHeader from "@/components/common/AppHeader.vue";
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  components: {
    // AppHeader
    Invoice
  },
  data() {
    return {
      s: this.$route.query.s,
      list: [
        { 'name':'超级Level-2',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity20240401?s=lxby&token=#V3TOKEN#"
       },
       { 'name':'六剑合一',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity202405142?s=lxby&token=#V3TOKEN#"

       },
       { 'name':'九转交易',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity202405141?s=lxby&token=#V3TOKEN#"

       },
       { 'name':'DDE决策',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity202405143?s=lxby&token=#V3TOKEN#"
       },
       { 'name':'抄底资金监控',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity202405145?s=lxby&token=#V3TOKEN#"
       },
       { 'name':'经典波段线',
           'url':"https://pay.dzh.com.cn/pay-mall/gateway?method=activity.activity202405144?s=lxby&token=#V3TOKEN#"
       }
      ],
      timeList: [
        {
          time: "连续包月",
          price: 39.9,
          old: "¥83",
          discounts: true //新用户专享
        },
        {
          time: "12个月",
          price: 998,
          old: "",
          discounts: false //新用户专享
        }
      ],
      tabCheckedIndex: 0,
      timeCheckedIndex: 0,
      checked: false,
      invoiceTitleType: 1,
      lastInvoiceTitleType: 1,
      orderId: this.$route.params.orderId,
      username: this.$storage.getUserName(),
      signMothed: this.$route.query.method,
      signParams: '',
      payHint:false,
      paySucceed: false,
      payMode:37,
      timer:'',
      payMoney: '39.9',
      oriMoney:'¥83',
      autoRenew: true,
      renewPaid: false,
      isRetrun: false,
      showRenewNotice: true,
    };
  },
  created() {
    var index = window.location.href.indexOf("?");
    if (index > -1) {
      this.signParams = window.location.href.substring(index);
    }
    if(!this.s){
      this.s = "";
    }
    if(!this.orderId || this.orderId === "0"){
      this.orderId = '';
    }
    //签约结果页面回调
    if(this.signMothed){
      this.signReturn(this.signMothed)
    }
    //校验用户是否存在收费权限
    this.checkPower()
  },
  mounted() {
    this.invoiceTitleType = this.$refs.invoice.invoiceTitleType;    
  },
  beforeDestroy(){
    if(this.timer && this.timer!=''){
      clearInterval(this.timer);
    }
  },
  methods: {
    changeAttach(val) {
      this.payHint = false;
      this.timeCheckedIndex = val;
      this.payMoney = this.timeList[val].price;
      this.oriMoney = this.timeList[val].old;
      this.checked = false;
      if(val === 1){
        this.autoRenew = false;
        this.showRenewNotice = false;
      }else{
        this.autoRenew = true;
        this.showRenewNotice = true;
      }
    },
    checkPower() {
      this.$get("/user/checkPower")
        .then(response => {
          if (response.code === 0) {
            this.timeList[0].price = 83.0;
            this.timeList[0].old = "";
            this.timeList[0].discounts = false;
            this.payMoney = this.timeList[0].price;
            this.oriMoney = this.timeList[0].old;
            if(this.isRetrun){
              this.isRetrun = false;
              return false;
            }
            this.$global.alert("您已有大智慧高端软件权限，无法参与本活动！");
          } else {
            this.timeList[0].price = 39.9;
            this.timeList[0].old = "¥83";
            this.timeList[0].discounts = true;
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    signReturn(val) {
      if(val !== 'alipay.user.agreement.page.sign.return'){
        this.$global.alert('非法请求');
        return;
      }
      this.paySucceed = true;
      this.renewPaid = true;
      this.isRetrun = true;
      // this.$get("/pay/signReturn", this.signParams)
      //   .then(response => {
      //     if (response.code === 0) {
      //       this.paySucceed = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.$global.alert(response.msg);
      //   });
    },
    saveOrder(){
      if(this.renewPaid && this.autoRenew){
        this.$global.alert("您已经购买大智慧365自动续费");
        return false;
      }
      if(!this.checked){
        this.payHint = true;
        return false;
      }
      // if(this.orderId){
      //   return false;
      // }
      var url = '/order/signOrderSave';
      var params = {
        productId: 116,
        monthCount: 1,
        orderType: 0,
        convertMoney: 0,
        invoiceTitleType: this.invoiceTitleType,
        questionsId: "0",
        buySource: this.s
      };
      if(this.timeCheckedIndex == 1){
        params.monthCount = 12
        this.payMode = 11
        url = '/order/save'
      }
      this.$post(url, params)
        .then(response => {
          if (response.code === 0) {
            this.orderId = response.data.id;
            this.getQrCode(this.orderId,this.payMode)
            this.payHint = false;
          } else {
            this.$global.alert(response.msg);
            }
          })
        .catch(err => {
        this.$global.alertError();
      });
    },
    getQrCode(val,val2) {
      if (this.lock) {
        return false;
      }
      var payUrl = '/pay/sign'
      var params = {
        id: val,
        payMode: val2
      };
      if(this.payMode == 11){
        payUrl = '/pay/web'
      }
      this.lock = true;
      this.$get(payUrl, params)
        .then(response => {
          if (response.code === 0) {
            var signCodeUrl = response.data;
            window.location.href = signCodeUrl;
          }else{
            this.$global.alert(response.msg);
          }
          this.lock = false;
        })
        .catch(err => {
          this.lock = false;
        });
    },
    jump(url){
      window.open(url, "_blank")
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
      if(this.invoiceTitleType !== this.lastInvoiceTitleType){
        this.lastInvoiceTitleType = this.invoiceTitleType;
        this.updatePaymentInvoiceTitleType()
      }
    },
    updatePaymentInvoiceTitleType(){
      this.$get("/order/updateInvoiceTitleType?orderId=" + this.orderId + "&invoiceTitleType=" + this.invoiceTitleType)
        .then(response => {
          if (response.code !== 0) {
            this.alert(response.msg)
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.app {
  background: linear-gradient(
    to bottom,
    #ffefd7 0%,
    #ffddb9 10%,
    #fcc297 30%,
    #fbd9c3 35%,
    #fdf6f2 50%
  );
  height: calc(100vh - 100px);
}
.top-title {
  text-align: center;
  p {
    &:first-child {
      color: #8d482e;
      font-size: 36px;
      padding-top: 38px;
    }
    &:last-child {
      color: #c36f4f;
      font-size: 24px;
      margin-top: 6px;
    }
  }
}
.content {
  position: fixed;
  width: 920px;
  border-radius: 16px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.c-bottom {
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hint {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
}

.hint a {
  color: #fff2af;
}

.c-bottom-left {
  width: 220px;
  height: 381px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 0px 8px #f9bb97;
  padding: 30px 40px;
}

.c-bottom-right {
  width: 510px;
  height: 381px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 0px 8px #f9bb97;
  padding: 30px 40px;
  margin-left: 11px;
  .right-title {
    color: #6c6c6c;
    font-size: 18px;
    text-align: center;
  }
}

.c-titlt1,
.c-titlt2 {
  color: #000000;
  font-size: 26px;
  font-weight: bold;
}

.c-titlt2 {
  margin-top: 10px;
}

.list-ul li {
  width: 172px;
  height: 34px;
  border: 1px solid #777777;
  border-radius: 35px;
  line-height: 34px;
  color: #333333;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px;
  cursor: pointer;
  margin-top: 14px;
}

.tabCheckedClass {
  background: #f09859;
  color: #ffffff !important;
  border: 1px solid #ffffff !important;
}

.timeList-ul {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 35px;
}

.timeList-ul li {
  width: 166px;
  height: 138px;
  background: #ffffff;
  border: 3px solid #ffe6b4;
  border-radius: 8px;
  margin-right: 21px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  line-height: 36px;
  position: relative;
  .checked {
    width: 32px;
    height: 32px;
    position: absolute;
    right: -2px;
    bottom: -2px;
  }
}

.timeList-ul li:hover {
  background: #fff6e4;
}

.timeList-ul li .time {
  color: #5b1d26;
  font-size: 14px;
  margin-top: 8px;
}
.timeList-ul li .price {
  color: #5b1d26;
  font-size: 40px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.timeList-ul li .price i {
  font-size: 14px;
}
.timeList-ul li .old {
  color: #87573c;
  font-size: 12px;
}

.timeList-ul .timeCheckedClass {
  background: #ffe6b4 !important;
}

.timeList-ul .old i {
  text-decoration: line-through;
}
.timeList-ul .discounts {
  background: linear-gradient(90deg, #e728ce 0%, #f20b10 100%);
  padding: 0 4px;
  border-radius: 6px 0 6px 0;
  color: #ffffff;
  position: absolute;
  height: 19px;
  line-height: 19px;
  top: -16px;
  left: -2px;
  font-size: 14px;
}

.pay-hint {
  color: #988050;
  font-size: 12px;
  background: #fff6e3;
  border-radius: 4px;
  padding: 4px 6px;
  display: inline-block;
  margin-top: 10px;
  position: relative;
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 8px solid transparent; /* 左边透明 */
    border-right: 8px solid transparent; /* 右边透明 */
    border-bottom: 8px solid #fff6e3; /* 底部实心箭头颜色 */
    display: inline-block; /* 行内块元素 */
    position: absolute;
    top: -6px;
  }
}

.c-bottom-pay {
  margin-top: 20px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  .open-btn {
    width: 150px;
    height: 41.41px;
    background: linear-gradient(90deg, #ff4040 0%, #ff7171 100%);
    border-radius: 8px;
    color: #ffffff;
    font-size: 22px;
    border: none;
    cursor: pointer;
  }
}

.c-bottom-pay .nth-child1 .style1 {
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}

.c-bottom-pay .nth-child1 .style2 {
  color: #ff0000;
  font-size: 22px;
}
.c-bottom-pay .nth-child1 .style3 {
  color: #555555;
  font-size: 14px;
  text-decoration: line-through;
  margin-left: 7px;
}

.c-bottom-pay .nth-child2 {
  color: #777777;
  font-size: 12px;
  margin-top: 12px;
}

.c-bottom-pay .nth-child2 a {
  color: #0085ff;
}

.c-bottom-pay .nth-child3 {
  color: #777777;
  font-size: 12px;
  margin-top: 10px;
}

.c-bottom-pay .nth-child3 a {
  color: #0085ff;
}

.shade-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.payment-success {
  width: 228px;
  height: 276px;
  background: #ffffff;
  border-radius: 16px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -114px;
  margin-top: -138px;
  z-index: 9;
  text-align: center;
  padding: 37px 0;
  line-height: 22px;
}

.affirm-btn {
  width: 82px;
  height: 36px;
  background: #ff2929;
  border-radius: 50px;
  color: #ffffff;
  font-size: 18px;
  margin-top: 15px;
  cursor: pointer;
}
.leave {
  width: 360px;
  height: 277px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -180px;
  margin-top: -138px;
  z-index: 9;
}

.leave .close {
  width: 34px;
  height: 34px;
  cursor: pointer;
  position: absolute;
  bottom: -50px;
  left: 50%;
  margin-left: -17px;
}

.leave .leave-con {
  width: 360px;
  height: 188px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
}
.leave-con-left {
  width: 55%;
}
.leave-con-right {
  width: 45%;
  .pop-up-open-btn {
    width: 121px;
    height: 34px;
    background: linear-gradient(90deg, #ff0025 0%, #ff4b65 100%);
    border-radius: 8px;
    border: none;
    color: #ffffff;
    font-size: 16px;
    margin-top: 15px;
    cursor: pointer;
  }
}
.leave-con-left,
.leave-con-right {
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leave .l-nth-child1 {
  color: #992d3c;
  font-size: 18px;
}
.leave .l-nth-child2 {
  color: #ff0025;
  font-size: 50px;
  margin-top: 10px;
}

.leave .l-nth-child2 i {
  font-size: 20px;
}
.leave .l-nth-child3 {
  color: #ff0000;
  font-size: 12px;
}

.leave .l-nth-child3 i {
  text-decoration: line-through;
}

.leave-con-right .code {
  width: 114px;
  color: #eab97e;
  font-size: 10px;
  text-align: center;
}

.btm-hint {
  color: #ababab;
  font-size: 12px;
  margin-top: 17px;
  text-align: center;
}

.payHint {
  position: fixed;
  width: 400px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.18);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 23px 28px;
  .title {
    color: #333333;
    font-size: 20px;
  }
  .msg {
    color: rgba(85, 85, 85, 1);
    font-size: 14px;
    margin-top: 18px;
    line-height: 23px;

    a {
      color: rgba(5, 105, 255, 1);
    }
  }
  .btn {
    width: 93px;
    height: 27px;
    background: #096bff;
    border-radius: 8px;
    border: none;
    color: #ffffff;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
  }
  .el-icon-close {
    position: absolute;
    right: 36px;
    top: 30px;
    font-size: 24px;
    cursor: pointer;
  }
}

.paySucceed {
  position: fixed;
  width: 216px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.18);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 23px 28px;
  text-align: center;
  .title {
    color: #000000;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin-left: 10px;
    }
  }
  .msg {
    color: #333333;
    font-size: 16px;
    margin-top: 18px;
    line-height: 23px;
  }
  .btn {
    width: 82px;
    height: 32px;
    background: #086bff;
    border-radius: 50px;
    border: none;
    color: #ffffff;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
  }
  .el-icon-close {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 24px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/newUserActivity0628.vue